











import { Vue, Component } from "vue-property-decorator";
import * as user from "../../_store/user.module";
import * as auth from "../../_store/auth.module";
import { bus } from "../../main";
import { userUtils } from "../../_utils/userUtils";
import NoPage from "../../components/Error/NoPage.vue";

@Component({
  components: {
    NoPage
  }
})
export default class CurriculumVitae extends Vue {
  created() {
    var token = localStorage.getItem("userToken");
    var parsedToken: any;
    if (token !== null) {
      parsedToken = userUtils.parseToken(token);
    }
    var payload = {
      idUtente: parsedToken.IdUtente,
      tipoSoggetto: parsedToken.IdTipoSoggetto,
      username: parsedToken.Username
    };
    user
      .dispatchSetStudentInfo(this["$store"], payload)
      .then(() => {
          bus.$emit("loadMenu");
        // user
        //   .dispatchSetInstituteInfo(this["$store"])
        //   .then(() => {
        //     bus.$emit("loadMenu");
        //   })
        //   .catch(() => {
        //     bus.$emit("stopLoading");
        //     auth.dispatchLogout(this["$store"]);
        //     user.dispatchClearState(this["$store"]);
        //     this["$router"].push("/sessionExpired");
        //   });
      })
      .catch(() => {
        bus.$emit("stopLoading");
        auth.dispatchLogout(this["$store"]);
        user.dispatchClearState(this["$store"]);
        this["$router"].push("/sessionExpired");
      });
  }
}
